<div>
  <sdps-modal id='view-symbol-modal' [sdpsTitle]="modalTitle" [size]="'flex--large'"
             aria-label="View Symbols Modal" [backDropCloseDisabled]="true">
    <div slot="modal-body">
      <sdps-notification type="error" class="sdps-m-top_none" *ngIf="toEnableErrorNotifications().length > 0">
        <div class="sdps-notification__text">
          <p>Please correct following error.</p>
          <ul class="sdps-navigation--horizontal__list error-list">
            <li *ngFor="let message of toEnableErrorNotifications()" [innerHTML]="message">
            </li>
          </ul>
        </div>
      </sdps-notification>
      <div class="view-history-container modal-container">
        <ems-table-record-count [count]="totalRecords" (emitter)="pageObject.pageNo = 0;pageObject.pageSize = $event;applyFilter()"
          [showRecords]="paginationCount !== 0 ? (paginationCount && paginationCount > getSharedConstant.defaultTableRecords ? true : false) : (tickerSymbolData && tickerSymbolData.length && tickerSymbolData.length > getSharedConstant.defaultTableRecords ? true : false)"
          [showHeaderIcons]="true" [groupTotal]="totalRecords" [showTotalForSecurities]="totalRecords"></ems-table-record-count>
        <div class="sdps-m-around_none">
          <div>
            <p-table #tt [columns]="colHeader" [value]="tickerSymbolData" [sortOrder]=1 sortMode="multiple"
              [rows]="pageObject.pageSize"  metaKeySelection="true" #indTable [customSort]="true"
              dataKey="id" [lazy]="true" (onLazyLoad)="customSort($event)" [multiSortMeta]="multiSortMeta"
              class="common-data-table">
              <ng-template #sorticon pTemplate="sorticon" let-sortOrder>
                <span class="pi" [ngClass]="{
                                              'pi-sort': sortOrder === 0,
                                              'pi-caret-down': sortOrder === -1,
                                              'pi-caret-up': sortOrder === 1,
                                            }"></span>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <!-- Column header section -->
                  <th class="table-checkbox-selection filter-icon" scope="col" aria-label="Filter controls">
                    <span class="sr-only">Filter controls</span>
                    <button type="button" class="btn-icon-only cursor" (click)="toggleFunction()" aria-label="Toggle filter" [attr.aria-expanded]="toggle">
                      <em class="pi pi-filter" aria-hidden="true"></em>
                    </button>
                  </th>
                  <ng-container *ngFor="let col of columns">
                    <th scope="col" *ngIf="col.field !== 'actions'" [pSortableColumn]="col.field"
                      [pSortableColumnDisabled]="(col.field==='actions')"
                      [ngClass]="customSortCSSRender"
                      [ngClass]="col.field === 'tickerSymbol' ? 'search-text-highlight' : null">
                      {{col.header}}
                      <p-sortIcon [field]="col.field" *ngIf="customSortCss(col.field)"
                        [ariaLabel]="commonConstants.sorting.sortText" [ariaLabelDesc]="commonConstants.sorting.descText"
                        [ariaLabelAsc]="commonConstants.sorting.ascText"></p-sortIcon>
                    </th>
                    <th *ngIf="col.field === 'actions' && toggle " [ngClass]="'w-200-px'" scope="col" aria-label="Filter actions">
                      {{col.header}}
                    </th>
                  </ng-container>
                </tr>
                <!-- Filter row section -->
                <tr *ngIf="toggle" class="filtered-row-input">
                  <th aria-label="Filter row"><span class="sr-only">Filter row</span></th>
                  <th *ngFor="let col of columns ;let i = index;" class="sdps-p-left_small">
                    <form [formGroup]="securityListFilterForm">
                      <label class="sr-only" for="securityFilterTickerSymbol" *ngIf="col.field === 'tickerSymbol'">{{col.header + ' filter'}}</label>
                      <input id="securityFilterTickerSymbol" [attr.aria-label]="col.header + ' filter'" pInputText formControlName="tickerSymbol" class="w-100-per" type="text"
                        name="tickerSymbol" [maxLength]="100" *ngIf="col.field === 'tickerSymbol'"
                        (keydown.enter)="!(invalidTickerSymbol) ? applyFilter(): ''" onkeydown="return (event.keyCode !== 13);"
                        emsAlphaNumericSpecialCharacterValidation [ngClass]="{'invalidField' : invalidTickerSymbol}">
                      <label class="sr-only" for="securityFilterSecurityType" *ngIf="col.field === 'securityType'">{{col.header + ' filter'}}</label>
                      <div *ngIf="col.field === 'securityType'"
                        class="col-2 emtr-dropdown timePickerForm request-list-filter request-list-multiselect-font-size request-list-filter-multiselect">
                        <p-multiSelect inputId="securityFilterSecurityType" id="securityFilterSecurityType" [attr.aria-label]="col.header + ' filter'" formControlName="securityType"
                          [options]="getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList" [filter]="true" optionLabel="label"
                          [defaultLabel]="''" [displaySelectedLabel]="true" [showHeader]="true" [filterPlaceHolder]="'All'"
                          [selectedItemsLabel]="'All'" [showToggleAll]="true" [filter]="true">
                        </p-multiSelect>
                      </div>
                      <label class="sr-only" for="securityFilterName" *ngIf="col.field === 'name'">{{col.header + ' filter'}}</label>
                      <input id="securityFilterName" [attr.aria-label]="col.header + ' filter'" pInputText formControlName="name" class="w-100-per" type="text" name="name"
                        (keydown.enter)="!(invalidName)? applyFilter(): ''" onkeydown="return (event.keyCode !== 13);"
                        *ngIf="col.field === 'name'" [ngClass]="{'invalidField' : invalidName }">
                      <label class="sr-only" for="securityFilterCUSIP" *ngIf="col.field === 'cusip'">{{col.header + ' filter'}}</label>
                      <input id="securityFilterCUSIP" [attr.aria-label]="col.header + ' filter'" pInputText formControlName="cusip" class="w-100-per" type="text" name="cusip"
                        (keydown.enter)="!(invalidCusip ||securityListFilterForm.get('cusip').invalid )? applyFilter(): ''"
                        onkeydown="return (event.keyCode !== 13);" *ngIf="col.field === 'cusip'" [maxLength]="9"
                        (input)="onInputChange('cusip', $event)" emsAlphaNumericSpecialCharacterValidation
                        [ngClass]="{'invalidField' : invalidCusip || securityListFilterForm.get('cusip').invalid }">
                      <label class="sr-only" for="securityFilterSEDOL" *ngIf="col.field === 'sedol'">{{col.header + ' filter'}}</label>
                      <input id="securityFilterSEDOL" [attr.aria-label]="col.header + ' filter'" pInputText formControlName="sedol" class="w-100-per" type="text" name="sedol"
                        (keydown.enter)="!(invalidSedol || securityListFilterForm.get('sedol').invalid)? applyFilter(): ''"
                        onkeydown="return (event.keyCode !== 13);" *ngIf="col.field === 'sedol'" [maxLength]="7"
                        (input)="onInputChange('sedol', $event)"
                        [ngClass]="{'invalidField' : invalidSedol || securityListFilterForm.get('sedol').invalid}"
                        emsAlphaNumericPatterncheck>
                      <label class="sr-only" for="securityFilterISIN" *ngIf="col.field === 'isin'">{{col.header + ' filter'}}</label>
                      <input id="securityFilterISIN" [attr.aria-label]="col.header + ' filter'" pInputText formControlName="isin" class="w-100-per" type="text" name="isin"
                        (keydown.enter)="!(invalidIsin || securityListFilterForm.get('isin').invalid)? applyFilter(): ''"
                        onkeydown="return (event.keyCode !== 13);" *ngIf="col.field === 'isin'" [maxLength]="12"
                        [ngClass]="{'invalidField' : invalidIsin || securityListFilterForm.get('isin').invalid}"
                        (input)="onInputChange('isin', $event)" emsAlphaNumericPatterncheck>
                      <div *ngIf="col.field === 'actions'" class="w-200-px">
                        <button id="securityFilterApplyButton" class="buttons button-filter"
                          [innerHTML]="getSharedConstant.filterButton.clearAllButton"
                          [disabled]="!securityListFilterForm.dirty && !isSortingChanged"
                          (click)="isClickedClearBtn = true; filtersApply ? clickedClearButton(isSortingChanged) : resetForm(isSortingChanged)">
                        </button>
                        <button id="securityFilterClearButton" class="buttons button-save button-filter" (click)="applyFilter()"
                          [disabled]="invalidTickerSymbol || invalidName || invalidCusip || invalidSedol || invalidIsin || securityListFilterForm.invalid"
                          [innerHTML]="getSharedConstant.filterButton.applyFilterButton"></button>
                      </div>
                    </form>
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length + 1" class="sdps-text-center sdps-font-weight-bold"
                    [innerHTML]="getEmtrConstants.rulesConstant.autoComplete.noRecords"></td>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                <tr *ngIf="rowIndex < pageObject.pageSize" class="table-checkbox-selection" [pSelectableRow]="rowData">
                  <td></td>
                  <td *ngFor="let col of columns">
                    <span *ngIf="col.field === 'name'">{{rowData[col.field] | titlecase}}</span>
                    <span *ngIf="col.field !== 'name'">{{rowData[col.field]}}</span>
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <p-paginator *ngIf="tickerSymbolData && tickerSymbolData.length > 0" class="common-pagination"
              [rows]="pageObject.pageSize"
              [alwaysShow]="(paginationCount && paginationCount > getSharedConstant.defaultTableRecords ? true : false)"
              [totalRecords]="paginationCount !== 0 ? paginationCount : tickerSymbolData.length " (onPageChange)="paginate($event)"
              #p>
            </p-paginator>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Buttons -->
    <div slot="modal-footer">
      <div class="step-action-buttons sdps-pull-left">
        <button class="buttons" type="button" (click)="closeViewSymbolModal(); sharedService.closeModal('view-symbol-modal')" [innerHTML]="getEmtrConstants.rulesConstant.ruleGlobalConst.cancel"></button>
      </div>
    </div>
  </sdps-modal>
</div>
